import React from "react";
import { useTranslation } from "react-i18next";

const Unauthorized = () => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      style={{
        minHeight: "calc(100vh - 70px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <h1>403</h1>
      <p>{t("allgemein.keineBerechtigung")}</p>
    </div>
  );
};

export default Unauthorized;
